import GoogleMaps from './google-maps';
import Slick from './slick';

export default {
    init() {
        GoogleMaps.init();
        Slick.init();
    },
};
